import Vue from 'vue'
import VueTk from 'vue-tk'
import VueTkUI from 'vue-tkui'
import router from '../router/index'
import 'vue-tk/dist/vue-tk.css'
import 'vue-tkui/dist/vue-tkui.css'
import routeAuth from './routeAuth'
import iconfont from '../assets/json/icon.json'
import parseJson from '../assets/json/parse.json'
import config from 'config'

Vue.use(VueTk)
Vue.use(VueTkUI)
const options = {
  vue: Vue, // vue示例，tkAjax 的必需项
  router: router, // tkHistory 与 tkRouterAuth 的必需项
  autoCloseSplashscreen: true, // 自动关闭引导页，默认true
  fastclick: true, // 开启fastclick，默认true
  statusBar: { // 全局状态栏设置
    color: '#0091FF' // 状态栏颜色
  },
  container: { // tkContainer全局配置
    mobileView: true // 在pc上缩小显示范围到手机大小
  },
  history: { // tkHistory 配置
    transtionMode: 'auto'
  },
  ajax: { // tkAjax配置项
    global: { // 全局ajax配置
      headers: {
        'X-Parse-Application-Id': 'fnMwBXOaelHs6ImsJieFPSFttzApqphj',
        'X-Parse-REST-API-Key': '47D6zef3SGyOyWSf8QqLcVSEY0XIhKkx'
      }
    },
    $cloudAjax: { // 可以创建任意名称的ajax示例挂载到vue示例上
      baseURL: config.cloudUrl
    }
  },
  parse: { // tkParse配置项
    appId: 'fnMwBXOaelHs6ImsJieFPSFttzApqphj',
    restKey: '47D6zef3SGyOyWSf8QqLcVSEY0XIhKkx',
    baseURL: 'https://api.water-heater.mokekeji.com',
    model: parseJson
  },
  routerAuth: {
    rulers: routeAuth
  },
  icon: {
    mode: 'material', // 默认图标风格
    custom: {
      default: {
        code: 545165,
        data: iconfont,
        type: 'private',
        useClassAsName: true
      }
    }
  }
}
if (config.env && config.env === 'admin') {
  options.parse.masterKey = 'zfPmJgBeDRnuzgnxOfzrcq0P8RKT56Ht'
}
VueTk.init(options)



// WEBPACK FOOTER //
// ./src/init/init.js